import { html, SYSBaseElement } from "../../../src"
import type { SYSTableDefIds } from "../../../src"
import { T } from "../../../src/textapi"

export class ScreenSYSEPT extends SYSBaseElement {
  async getUI() {
    return html`
      <div class="fd-layout-panel ">
        <div
          class="fd-layout-panel__body fd-has-padding-base fd-has-margin-base"
        >
          <ovl-table
            class="fd-table fd-table--no-horizontal-borders"
            .props=${() => <SYSTableDefIds>"SYSEPT"}
          >
          </ovl-table>
        </div>
      </div>
    `
  }
}
